module.exports = "/packs/chevron-left-11b43988787b3048b44a2f5b29b81e81.svg";